<template>
  <div class="trusted-by__wrapper">
    <h2>TRUSTED BY THE BEST IN BUSINESS</h2>

    <homepage-swiper-with-logos
      :logos="$options.consts.LOGOS_SETTINGS"
      :swiper-pagination-custom-class="$options.consts.PAGINATION_CUSTOM_CLASS"
      class="trusted-by__carousel"
    />

    <a-visibility show :from="$breakpoint.tablet">
      <a-icon
        :icon="$options.consts.ICON.BACKGROUND_DOTS_2"
        width="auto"
        height="auto"
        :no-hover="true"
        :original="true"
        class="trusted-by__background-icon"
      />
    </a-visibility>
  </div>
</template>

<script>
import HomepageSwiperWithLogos from '@/components/_homepage/shared/HomepageSwiperWithLogos/index.vue'
import {
  LOGOS_SETTINGS,
  PAGINATION_CUSTOM_CLASS
} from '@/components/_homepage/HomepageTrustedBySection/enums'
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import { generateServerCacheKey } from '@/plugins/helper'

export default {
  name: 'HomepageTrustedBySection',
  serverCacheKey: () => generateServerCacheKey('HomepageTrustedBySection'),
  components: { AIcon, HomepageSwiperWithLogos },
  consts: {
    LOGOS_SETTINGS,
    PAGINATION_CUSTOM_CLASS,
    ICON
  }
}
</script>

<style lang="scss" scoped>
.trusted-by__wrapper {
  background: $c--blue-light-2;
  position: relative;

  $padding: (
    $above-desktop-xl: 75px $padding-x-desktop-full-hd 120px
      $padding-x-desktop-full-hd,
    $desktop-sm: 52px $padding-x-desktop-sm 92px,
    $mobile: 22px $padding-x-mobile
  );

  $margin-x: (
    $above-desktop-xl: -#{$padding-x-desktop-full-hd},
    $desktop-sm: -#{$padding-x-desktop-sm},
    $mobile: -#{$padding-x-mobile}
  );

  @include setStyleByBreakpoint('padding', $padding);
  @include setStyleByBreakpoint('margin-left', $margin-x);
  @include setStyleByBreakpoint('margin-right', $margin-x);

  .trusted-by__carousel {
    $margin-top: (
      $above-desktop-xl: 42px,
      $desktop-sm: 32px,
      $mobile: 20px
    );

    $margin-right: (
      $above-desktop-xl: -#{$padding-x-desktop-full-hd},
      $desktop-sm: -#{$padding-x-desktop-sm},
      $mobile: -#{$padding-x-mobile}
    );

    $margin-left: (
      $above-desktop-xl: -5px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
    @include setStyleByBreakpoint('margin-right', $margin-right);
    @include setStyleByBreakpoint('margin-left', $margin-left);
  }

  .trusted-by__background-icon {
    position: absolute;
    transform: translateY(50%);

    $width: (
      $above-desktop-xl: 144px,
      $desktop-sm: 81px,
      $mobile: 46px
    );

    $height: (
      $above-desktop-xl: 128px,
      $desktop-sm: 72px,
      $mobile: 42px
    );

    $bottom: (
      $above-desktop-xl: 0
    );

    $right: (
      $above-desktop-xl: 40px,
      $desktop-sm: 16px,
      $mobile: 9px
    );

    @include setStyleByBreakpoint('width', $width);
    @include setStyleByBreakpoint('height', $height);
    @include setStyleByBreakpoint('bottom', $bottom);
    @include setStyleByBreakpoint('right', $right);
  }
}
</style>
